import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useComputed, useSignal } from '@preact/signals-react'

const CommandCenterLink = ({children, eventkey, to }) => {

    const location = useLocation()

    let activeSignal = useSignal(false)

    useEffect(
        () => {
            let print = false
            if (print) {
                console.log("Location changed to ".concat(location.pathname))
            }
            const splat = location.pathname.split('/')
            if (splat && splat.length && splat.length >= 4) {
                if (splat[3] == eventkey) {
                    activeSignal.value = true
                    return
                }
            }
            activeSignal.value = false
        }, [location, activeSignal, eventkey]
    )

    const activityComputed = useComputed(
        () => {
            if (activeSignal.value) {
                return " active"
            }
            return ""
        }
    )

    return (
        <Link className={"nav-link".concat(activityComputed.value)} eventkey={eventkey} to={to}>{children}</Link> 
    )
}
export default CommandCenterLink